import { doGraphqlRequest } from 'ducks/requests'
import graphql from '../api'
import { INVOICE_PREVIEW_REQUEST } from '../types'

const mutation = `
  mutation draftOrderInvoicePreview($id: ID!, $email: EmailInput) {
    draftOrderInvoicePreview(id: $id, email: $email) {
      previewHtml
    }
  }
`

const doPreviewInvoice = (
  integrationId,
  draftOrderId,
  emailData
) => dispatch => {
  const variables = {
    id: draftOrderId,
    email: {
      to: emailData.to,
    },
  }

  return dispatch(
    doGraphqlRequest(INVOICE_PREVIEW_REQUEST, mutation, variables, {
      graphqlFunc: graphql(integrationId),
    })
  ).then(data => data.draftOrderInvoicePreview.previewHtml)
}

export default doPreviewInvoice
